import React, { memo } from 'react';
import { Grid, Theme } from '@material-ui/core';
import { withStyles, WithStyles, createStyles } from '@material-ui/core/styles';

import { FormattedMessage, useIntl } from 'react-intl';
import { ActionModal } from '../../../components/Modal';
import { Typography } from '../../../components/Typography';
import { IGroup, IGroupExternalMember, IGroupMember } from '../groups.slice';

const styles = (theme: Theme) => {
  return createStyles({
    userCard: {},
    right: {
      display: 'flex',
      justifyContent: 'space-between',
      flexDirection: 'column',
    },
  });
};

export interface IGroupInfoModalProps extends WithStyles<typeof styles> {
  selectedGroup: IGroup;
  showParent: boolean;
  open: boolean;
  handleClose: () => void;
}

const GroupInfoModal = ({
  classes,
  selectedGroup,
  showParent,
  open,
  handleClose,
}: IGroupInfoModalProps) => {
  const intl = useIntl();
  return (
    <ActionModal
      modalTitle={selectedGroup?.name}
      open={open}
      handleClose={handleClose}
      actinButtonLabel={intl.formatMessage({
        id: 'done',
      })}
      actinButtonOnClick={handleClose}
      isSingleButton
    >
      <Grid container className={classes.userCard}>
        <Grid item className={classes.right}>
          <Typography variant="body1" color="secondary">
            <FormattedMessage id="description" /> :&nbsp;
            {selectedGroup?.description}
          </Typography>
          <Typography variant="body1" color="secondary">
            <FormattedMessage id="members" /> :&nbsp;
            {selectedGroup?.members.map((member: IGroupMember) => {
              return `${member?.userId?.profile?.name} | ${member?.userId?.email}, `;
            })}
          </Typography>
          <Typography variant="body1" color="secondary">
            <FormattedMessage id="external_members" /> :&nbsp;
            {selectedGroup?.externalMembers.map(
              (externalMember: IGroupExternalMember) => {
                return `${externalMember?.email}, `;
              }
            )}
          </Typography>
          {showParent ? (
            <Typography variant="body1" color="secondary">
              <FormattedMessage id="managed_by" /> :&nbsp;
              {selectedGroup?.parentId?.profile?.name}
            </Typography>
          ) : (
            ''
          )}
          {/* <Typography variant="body1" color="secondary">
            <FormattedMessage id="participants" /> : &nbsp;
            {meeting?.participantCount}
          </Typography> */}
        </Grid>
      </Grid>
    </ActionModal>
  );
};

export default memo(withStyles(styles)(GroupInfoModal));
